import React, {useState} from 'react';
import {Modal} from 'antd';
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";

const ModalComponent = ({open, handleSetOpen}) => {
    const navigation = useNavigate();
    const [confirmLoading, setConfirmLoading] = useState(false);

    const handleOk = async () => {
        setConfirmLoading(true);
        await Cookies.remove('access_token')
        await Cookies.remove('username')
        await Cookies.remove('company_name')
        await Cookies.remove('company_logo')
        navigation('/login')
    };
    const handleCancel = () => {
        handleSetOpen(false);
    };
    return (
        <Modal
            title="خروج از حساب"
            open={open}
            onOk={handleOk}
            okText={`تائید`}
            okButtonProps={{
                style: {backgroundColor: 'red'}
            }}
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
            cancelText={`لغو`}
        >
            <p>آیا برای خروج از حساب اطمینان دارید؟</p>
        </Modal>
    );
};
export default ModalComponent;